import React from 'react';
import { Form, Row, Col, Button, Divider, message, Select } from "antd";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import { COMPANY_FINANCIALS_FIELDS } from "constants/form-fields";
import { INPUT_TYPES } from "../../constants/input-types";
import { OnboardingService } from '../../services';

class CompanyFinancialsForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    state = {
        formValues: {},
        addSlabVisible: false,
        createSlabLoader: false,
        turnoverDetails: this.props.companyBackgroundData?.size > 0 && this.props.companyBackgroundData?.get("turnover_details") || [],
        profitabilityDetails: this.props.companyBackgroundData?.size > 0 && this.props.companyBackgroundData?.get("profitability_details") || [],
        netWorthDetails: this.props.companyBackgroundData?.size > 0 && this.props.companyBackgroundData?.get("net_worth_details") || [],
    }

    handleFieldValueChange = (fieldName, value) => {
        // console.log("inside handleFieldValueChange", fieldName, value);
    }

    onApprove = (e) => {
        e.preventDefault();
        const formValues = {};
        const formFields = COMPANY_FINANCIALS_FIELDS;
        formFields.forEach((field, fieldName) => {
            formValues[fieldName] = this.props.form.getFieldValue(fieldName);
        });

        this.props.form.validateFields((err, values) => {
            if (!err) {
                const formData = this.props.form.getFieldsValue()

                const validateUniqueYears = (details) => {
                    const years = details?.map(item => Number(item.year));
                    const duplicates = years?.filter((year, index) => years?.indexOf(year) !== index);
                    return duplicates?.length > 0;
                };
                const { turnoverDetails, profitabilityDetails, netWorthDetails } = this.state;
                const updatedTurnoverDetails = turnoverDetails.length === 0 ? null : turnoverDetails;
                const updatedProfitabilityDetails = profitabilityDetails.length === 0 ? null : profitabilityDetails;
                const updatedNetWorthDetails = netWorthDetails.length === 0 ? null : netWorthDetails;
                if (updatedTurnoverDetails?.length > 0 && validateUniqueYears(updatedTurnoverDetails) ||
                    updatedProfitabilityDetails?.length > 0 && validateUniqueYears(updatedProfitabilityDetails) ||
                    updatedNetWorthDetails?.length > 0 && validateUniqueYears(updatedNetWorthDetails)) {
                    message.error('Duplicate years found in turnover details, profitability details, or net worth details. Please ensure each year is unique.')
                    return;
                }
                formData["turnover_details"] = updatedTurnoverDetails;
                formData["profitability_details"] = updatedProfitabilityDetails;
                formData["net_worth_details"] = updatedNetWorthDetails;
                Object.keys(formData).forEach((key) => {
                    if (key.startsWith("associates") && key !== "associates") {
                        delete formData[key];
                    }
                });
                formData["company_id"] = this.props.companyId;
                formData["mpa_approval"] = this.props.currentMpaId;
                if (this.props.companyBackgroundData?.size > 0) {
                    OnboardingService.postCompanyBackgroundApi("patch", this.props.companyBackgroundData?.get("id"), formData).then(res => {
                        // OnboardingService.postCompanyBackgroundApi("patch", 4, formData).then(res => {
                        if (res.status === 200) {
                            message.success("Company Financials Data Updated")
                        }
                    }).catch((err) => {
                        console.log("inside catch background", err);
                        message.error(err && err?.data?.detail || "Something went wrong")
                    })
                } else {
                    OnboardingService.postCompanyBackgroundApi("post", null, formData).then(res => {
                        message.success("Data Updated")
                    }).catch((err) => {
                        console.log("inside catch background", err);
                        message.error(err && Object.values(err)[0] || "Something went wrong")
                    })
                }
            }
        })
    }

    getFormValues = (formKey) => {
        const formValues = {};
        const formFields = this.state.forms[formKey];
        for (const fieldName in formFields) {
            formValues[fieldName] = formFields[fieldName].value;
        }
        return formValues;
    }

    generatePreviousFiveYears = () => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();
        const startYear = currentMonth <= 2 ? currentYear - 1 : currentYear;
        // const startYear = currentYear;
        return Array.from({ length: 5 }, (_, i) => (startYear - i).toString());
    };

    handleAddRow = (section) => {
        this.setState((prevState) => ({
            [section]: [...prevState[section], { year: '', amount: '' }]
        }));
    };

    handleRemoveRow = (section, index) => {
        this.setState((prevState) => {
            const updatedSection = [...prevState[section]];
            updatedSection.splice(index, 1);
            return { [section]: updatedSection };
        });
    };

    handleFieldsValueChange = (section, index, key, value) => {
        this.setState((prevState) => {
            const updatedSection = [...prevState[section]];
            updatedSection[index] = {
                ...updatedSection[index],
                [key]: value,
            };
            return { [section]: updatedSection };
        });
    };


    renderSection = (section, fields) => {
        const data = this.state[section];
        const years = this.generatePreviousFiveYears();
        return (
            <Row className='w-100'>
                {data.map((item, index) => (
                    <Row key={index} gutter={[16, 16]} align="middle">
                        {fields.map((field) => (
                            <Col span={10} key={field.key} style={{ marginRight: "2rem" }}>
                                <Form.Item
                                    label={field.label}
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    style={{ marginBottom: "12px" }}
                                >
                                    {field.key.includes("financial_year_starting") ? (
                                        <Form.Item
                                            key={`${field.key}${index}`}
                                            // label={field.label}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Field is Required",
                                                },
                                            ]}
                                        >
                                            {this.props.form.getFieldDecorator(`${field.key}${index}`, {
                                                initialValue: item[field.valueKey],
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Field is Required",
                                                    },
                                                ],
                                            })(
                                                <Select
                                                    onChange={(value) =>
                                                        this.handleFieldsValueChange(section, index, field.valueKey, value)
                                                    }
                                                >
                                                    {years.map((year) => (
                                                        <Select.Option key={year} value={year}>
                                                            {year}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    ) : (
                                        this.fieldGenerator(
                                            `${field.key}${index}`,
                                            {
                                                key: `${field.key}${index}`,
                                                dataIndex: `${field.key}${index}`,
                                                type: field.type,
                                                className: "fb-20 mr-3perc",
                                                value: item[field.valueKey],
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Field is Required"
                                                    }
                                                ],
                                            },
                                            this.getValidateStatus(`${field.key}${index}`),
                                            (e) =>
                                                this.handleFieldsValueChange(
                                                    section,
                                                    index,
                                                    field.valueKey,
                                                    field.type === INPUT_TYPES.NUMBER ? parseFloat(e.target.value) : e.target.value
                                                ),
                                            true
                                        )()
                                    )}
                                </Form.Item>
                            </Col>
                        ))}
                        <Col span={2} style={{ marginTop: "1.7rem" }}>
                            <Form.Item style={{ marginBottom: "12px" }}>
                                <Button onClick={() => this.handleRemoveRow(section, index)}>Remove</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                ))}
                {<Row className='w-100'>
                    <Col span={22}></Col>
                    <Col span={2} className='mb-20'>
                        <Button type="dashed" onClick={() => this.handleAddRow(section)} block>
                            Add Row
                        </Button>
                    </Col>
                </Row>}
            </Row>
        );
    };

    render() {
        return (
            <div className={"d-flex flex-row justify-content-space-between flex-wrap w-100 form"}>
                <Form key="feeForm" onSubmit={this.onApprove}>
                    <Row>
                        {/* {this.props.companyBackgroundData?.size > 0 && this.props.companyBackgroundData?.get("turnover_details") && ( */}
                        {(
                            <Col span={24}>
                                <h3> Turnover Details </h3>
                            </Col>
                        )}
                        {this.renderSection('turnoverDetails', [
                            { key: "financial_year_starting_turnover", label: "Financial Year Starting", type: INPUT_TYPES.NUMBER, valueKey: "year" },
                            { key: "turnover", label: "Turnover(In Crs)", type: INPUT_TYPES.NUMBER, valueKey: "amount" },
                        ])}
                        {/* {this.props.companyBackgroundData?.size > 0 && this.props.companyBackgroundData?.get("profitability_details") && ( */}
                        {(
                            <Col span={24}>
                                <h3> Profitability Details </h3>
                            </Col>
                        )}
                        {this.renderSection('profitabilityDetails', [
                            { key: "financial_year_starting_profitability", label: "Financial Year Starting", type: INPUT_TYPES.NUMBER, valueKey: "year" },
                            { key: "profit_profitability", label: "Profit(In Crs)", type: INPUT_TYPES.NUMBER, valueKey: "amount" },
                        ])}
                        {/* {this.props.companyBackgroundData?.size > 0 && this.props.companyBackgroundData?.get("net_worth_details") && ( */}
                        {(
                            <Col span={24}>
                                <h3> Net Worth Details </h3>
                            </Col>
                        )}
                        {this.renderSection('netWorthDetails', [
                            { key: "financial_year_starting_net_worth", label: "Financial Year Starting", type: INPUT_TYPES.NUMBER, valueKey: "year" },
                            { key: "net_worth", label: "Net Worth(In Crs)", type: INPUT_TYPES.NUMBER, valueKey: "amount" },
                        ])}
                        {COMPANY_FINANCIALS_FIELDS.map((field, fieldName) => {
                            // field.disabled = this.props.disableFields;
                            const value = this.props.values && this.props.values.get(fieldName);
                            return <Col span={field.col}>{this.fieldGenerator(
                                fieldName,
                                { ...field, value },
                                this.getValidateStatus(fieldName),
                                (e) => this.handleFieldValueChange(fieldName, (field.type == "SELECT" ? e : e.target.value)),
                                true
                            )()}</Col>
                        }).toList()}
                        {this.props.companyBackgroundData?.size > 0 && this.props.companyBackgroundData?.get("associates") && (
                            <Col span={24}>
                                <h3> CIBIL Details </h3>
                            </Col>
                        )}
                        {this.props.companyBackgroundData?.size > 0 ? this.props.companyBackgroundData?.get("associates")?.map((associate, index) => (
                            <React.Fragment key={index}>
                                <Col span={12}>
                                    <Form.Item>
                                        {this.fieldGenerator(
                                            `associates${index}.applicant_name`,
                                            {
                                                key: `associates${index}.applicant_name`,
                                                dataIndex: `associates${index}.applicant_name`,
                                                label: `Applicant Name`,
                                                type: INPUT_TYPES.TEXT,
                                                className: "form-field fb-20 mr-3perc",
                                                value: associate.full_name,
                                                disabled: true
                                            },
                                            this.getValidateStatus(`associates${index}.applicant_name`),
                                            true
                                        )()}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item>
                                        {this.fieldGenerator(
                                            `associates${index}.cibil_score`,
                                            {
                                                key: `associates${index}.cibil_score`,
                                                dataIndex: `associates${index}.cibil_score`,
                                                label: `Cibil Score`,
                                                type: INPUT_TYPES.NUMBER,
                                                className: "form-field fb-20 mr-3perc",
                                                value: associate.cibil_score,
                                                disabled: true
                                            },
                                            this.getValidateStatus(`associates${index}.cibil_score`),
                                            true
                                        )()}
                                    </Form.Item>
                                </Col>
                            </React.Fragment>
                        )) :
                            <div>
                                <h3>Applicant CIBIL Details</h3>
                                <h4 style={{ color: "red" }}>No Details available/No Cibil Score available</h4>
                            </div>}
                    </Row>
                    <Row>
                        <Col span="20"></Col>
                        <Col span="4"><Button type="primary" block htmlType="submit">Save</Button></Col>
                    </Row>
                </Form>
                <Divider />
            </div>
        );
    }
}
export default Form.create({
    mapPropsToFields: ({ values, companyBackgroundData }) => {
        const fields = {};
        if (!companyBackgroundData) {
            return new Map();
        }
        if (companyBackgroundData) {
            companyBackgroundData.forEach((value, key) => {
                if (key === "associates") {
                    value?.length > 0 && value.forEach((associate, index) => {
                        fields[`associates${index}.applicant_name`] = Form.createFormField({
                            value: associate.full_name
                        });
                        fields[`associates${index}.cibil_score`] = Form.createFormField({
                            value: associate.cibil_score
                        });
                    });
                } else if (key === "turnover_details") {
                    value?.length > 0 && value.forEach((value, index) => {
                        fields[`financial_year_starting_turnover${index}`] = Form.createFormField({
                            value: value.year
                        });
                        fields[`turnover${index}`] = Form.createFormField({
                            value: value.amount
                        });
                    });
                } else if (key === "profitability_details") {
                    value?.length > 0 && value.forEach((value, index) => {
                        fields[`financial_year_starting_profitability${index}`] = Form.createFormField({
                            value: value.year
                        });
                        fields[`profit_profitability${index}`] = Form.createFormField({
                            value: value.amount
                        });
                    });
                } else if (key === "net_worth_details") {
                    value?.length > 0 && value.forEach((value, index) => {
                        fields[`financial_year_starting_net_worth${index}`] = Form.createFormField({
                            value: value.year
                        });
                        fields[`net_worth${index}`] = Form.createFormField({
                            value: value.amount
                        });
                    });
                } else {
                    fields[key] = Form.createFormField({
                        value
                    });
                }
            });
        }
        return fields;
    },
    onValuesChange: (props, changedValues, values) => {
    }
})(CompanyFinancialsForm);
